export function canOpenHost(record, permitted) {
  return Boolean(
    permitted &&
    record?.canManage &&
    record?.hostReady === true &&
    ["Scheduled", "Live"].includes(record?.status),
  );
}

export function hostReadinessMessage(record) {
  if (
    !record?.canManage ||
    record?.hostReady == null ||
    !["Scheduled", "Live"].includes(record?.status)
  )
    return null;
  if (record.hostReady) return null;
  if (record.hostReadyReason === "invitation_pending")
    return "Zoom invitation pending. Check your email and accept the invitation before starting.";
  if (record.hostReadyReason === "disabled")
    return "Your Zoom host account is disabled. Ask a System Administrator to provision it again.";
  return "No Zoom host account is provisioned. Ask a System Administrator to provision your host account.";
}

export function canJoinSession(record, permitted) {
  return Boolean(
    permitted &&
    record?.external_id &&
    ["Scheduled", "Live"].includes(record?.status),
  );
}

export function canEditSession(record, permitted) {
  return Boolean(
    permitted &&
    record?.canManage &&
    record?.status === "Scheduled" &&
    !record?.external_id,
  );
}

export function normalizeLmsPermissions(permissions) {
  return (Array.isArray(permissions) ? permissions : []).map((permission) => {
    let apiPath = permission.regex_path || permission.api_path;
    if (!permission.regex_path && permission.wildcard && permission.api_path) {
      const escaped = permission.api_path.replace(
        /[.*+?^${}()|[\]\\]/g,
        "\\$&",
      );
      apiPath = `^${escaped}(?:/.*)?$`;
    }
    return { ...permission, api_path: apiPath };
  });
}
